










































































import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
// @ts-ignore
import store from "../../store";
import {Tool} from "../../helpers/Tool";
// @ts-ignore
import Tools from "../../helpers/Tools";
import MessageHelper from "../../helpers/MessageHelper";
import type {CurrentGame, GameSettings, Player, PlayerData} from "../../../types";
import EventApi from "../../api/EventsApi";
import {LayoutTypes} from "../../../enums/layout-types/LayoutTypes";

@Component({
    components: {},
    props: {}
})

export default class PlayerInfo extends Vue {
    @Prop({required: true}) private readonly player!: Player;
    @Prop({required: true}) private readonly isPlayerSettingsVisible!: boolean;

    private canToggleVideo: boolean = true;

    mounted(): void
    {
        EventApi.addEventListener(EventApi.SHOW_VIDEO, () => {
            this.canToggleVideo = true;
        });
        EventApi.addEventListener(EventApi.HIDE_VIDEO, () => {
            this.canToggleVideo = false;
        });

        window.addEventListener('resize', () => {this.pointsFontSize(this.getPlayerPoints())});
    }

    /**
     * Статус камеры
     */
    private cameraIsOn(): boolean
    {
        return this.$conferenceManager.devicesManager.cameraStatus;
    }

    /**
     * Статус микрофона
     */
    private micIsOn(): boolean
    {
        return this.$conferenceManager.devicesManager.microphoneStatus;
    }

    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    private get currentActivity(): CurrentGame
    {
        return store.getters.getCurrentActivity;
    }

    private get currentActivitySettings(): GameSettings|null
    {
        if (!this.currentActivity) {
            return null;
        }
        return this.currentActivity.settings;
    }

    /**
     * Видны ли очки игроков
     */
    private get playerPointsAreVisible(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canViewPlayerPoints;
    }

    /**
     * Видно ли кол-во карт игрока
     */
    private get playerCardsAreVisible(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canViewPlayersCards;
    }

    private get players(): Array<Player>
    {
        return store.getters.getPlayers;
    }

    private get isCurrentPlayer(): boolean
    {
        return this.playerId === this.player.id;
    }

    /**
     * Тип лейаута
     * @private
     */
    private get layoutType(): string
    {
        return store.getters.getCurrentLayoutType;
    }

    /**
     * Установить размер шрифта
     * @param points
     * @private
     */
    private pointsFontSize(points: number)
    {
        if (this.layoutType === LayoutTypes.LAYOUT_TASK) {
            if (window.innerWidth >= 1200) {
                return points >= 100 || points < -9 ? '10px' : '12px';
            }
            if (window.innerWidth >= 1900) {
                return points >= 100 || points < -9 ? '14px' : '16px';
            }
        }

        if (window.innerWidth >= 1200 && window.innerWidth < 3800) {
            return points >= 100 || points < 0 ? '16px' : '24px';
        }
        if (window.innerWidth >= 3800) {
            return points >= 100 || points < -9 ? '28px' : '36px';
        }

        return points >= 100 || points < 0 ? '16px' : '24px';
    }

    /**
     * Id для поля игрока
     * @param field
     * @return {string}
     */
    private getPlayerFieldId(field: string)
    {
        return Tool.createPlayerFieldId(field, this.player.id);
    }

    /**
     * Игрок по айди
     */
    private getPlayerById(playerId: string): Player|null
    {
        if (!this.players) {
            return null;
        }
        const players = this.players.filter((item) => {
            return item.id === playerId;
        });

        if (players.length === 0) {
            return null;
        }

        return players[0];
    }

    /**
     * Получить состояние камеры игрока
     * @returns {boolean}
     */
    private isPlayerCameraEnabled(): boolean
    {
        const player: Player|null = this.getPlayerById(this.player.id);
        if (player) {
            return player.video.cameraStatus;
        }
        return false;
    }

    /**
     * Получить состояние микрофона игрока
     */
    private isPlayerMicrophoneEnabled(): boolean
    {
        const player: Player|null = this.getPlayerById(this.player.id);
        if (player) {
            return player.video.microphoneStatus;
        }
        return false;
    }

    /**
     * Данные игрока
     * @return {null|*}
     */
    private getPlayerData(): PlayerData|null
    {
        if (typeof store.getters.getGameState.playersData === "undefined") {
            return null;
        }

        let playersData = store.getters.getGameState.playersData;

        if (typeof playersData[this.player.id] === "undefined") {
            return null;
        }

        return playersData[this.player.id];
    }

    /**
     * Очки игрока
     */
    private getPlayerPoints(): number
    {
        let playerData = this.getPlayerData();

        if (playerData === null) {
            return 0;
        }

        return playerData.points ? playerData.points : 0;
    }

    /**
     * Изменить имя игрока
     */
    private changePlayerName(name: string)
    {
        Tools.runTimer('changePlayerName', () => {
            const data = {
                playerId: this.player.id,
                name: name
            };
            MessageHelper.changePlayerNameMessage(data);
        });
    }

    /**
     * Имя игрока
     */
    private getPlayerName()
    {
        let playerData = this.getPlayerData();

        if (playerData === null) {
            return '';
        }

        return playerData.name;
    }

    /**
     * Контрастный цвет игрока
     */
    private getPlayerColorContrast(): string
    {
        if (this.player.hasOwnProperty('color') && this.player.color.hasOwnProperty('contrast')) {
            return this.player.color.contrast;
        }
        return '';
    }

    /**
     * Вкл/выкл микрофон
     * @private
     */
    private changeMicrophoneStatus(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('change-microphone-status', !this.micIsOn());
        (this.$refs.micBtn as HTMLElement).blur();
    }

    /**
     * Вкл/выкл камеру
     * @private
     */
    private changeCameraStatus(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.$emit('change-camera-status', !this.cameraIsOn());
        (this.$refs.camBtn as HTMLElement).blur();
    }
}
